import { BaseResource } from "./BaseResource";
import { apiResourceUrl } from "@ploy-lib/core";
class VendorProductGroupResource extends BaseResource {
    pk() {
        return this.vendorProductGroupId.toString();
    }
}
VendorProductGroupResource.urlRoot = apiResourceUrl("vendorProductGroups");
export { VendorProductGroupResource };
//# sourceMappingURL=VendorProductGroupResource.js.map